import { makeSelectors, combineTokens } from '@utils/css';
import { colors } from '../../design-tokens/colors.js';

const iconTransitionDurationMs = 150;
const tokens = combineTokens("--icon-button", {
  color: colors.gray.sim100
});
const modifiers = makeSelectors({
  small: "dibs1gfiqsv",
  withLabel: "dibw1nwoj4u"
});
const buttonCls = "dibb1xahw7n";
const iconsContainerCls = "dibi19cjy2z";
const iconWrapperCls = "dibios944q";
const throbberCls = "dibt1b98gy";
const successCls = "dibsehgo7c";
const errorCls = "dibensi9ru";
const label = "diblw09hcu";
const checkmark = "dibc13yxxze";
const iconButtonSelectors = makeSelectors({
  button: buttonCls,
  iconsContainer: iconsContainerCls,
  iconWrapper: iconWrapperCls,
  throbber: throbberCls
});

export { buttonCls, checkmark, errorCls, iconButtonSelectors, iconTransitionDurationMs, iconWrapperCls, iconsContainerCls, label, modifiers, successCls, throbberCls, tokens };
import "./icon-button.style.linaria.module.css";
//# sourceMappingURL=icon-button.style.js.map
